import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';

import Cookies from 'js-cookie';
import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';

import MdComponents from './baseComponents';
import Form from './form';
import AppComponents from './appComponents';
import { createStore } from './store';
import { router } from './router';
import App from './App.vue';

if (process.env.NODE_ENV === 'production') {
    Raven
        .config('https://5205673a8d3045fa8f64d705b8b5f872@sentry.io/188259')
        .addPlugin(RavenVue, Vue)
        .install();
}

Vue.use(MdComponents);
Vue.use(Form);
Vue.use(AppComponents);
Vue.use(VueRouter);
Vue.use(Vuex);

const store = new Vuex.Store(createStore({
    authorized: !!Cookies.get('token'),
}));

store.subscribe(({ type, payload }) => {
    switch (type) {
        case 'authorize':
            router.push(payload ? '/' : '/sign/login');
            break;
    }
});

store.dispatch('orgTypes/fetchOrgTypes');
store.dispatch('fileUploader/fetchFileTypes');
store.dispatch('regions/fetchRegions');
if (store.state.authorized) {
    store.dispatch('request/fetchAvailableProducts')
    store.dispatch('profileTariff/fetchProfileTariff')
}

new Vue({
    el: '#app',
    store,
    router,
    render: (h) => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js